function filterData(_ref) {
  var data = _ref.data,
    searchable = _ref.searchable,
    limit = _ref.limit,
    searchValue = _ref.searchValue,
    filter = _ref.filter,
    value = _ref.value,
    disableSelectedItemFiltering = _ref.disableSelectedItemFiltering,
    enhancedFilter = _ref.enhancedFilter;
  if (!searchable && value.length === 0) {
    return data;
  }
  if (!searchable) {
    var _result = [];
    var _loop = function _loop(i) {
      if (!!disableSelectedItemFiltering || !value.some(function (val) {
        return val === data[i].value && !data[i].disabled;
      })) {
        _result.push(data[i]);
      }
    };
    for (var i = 0; i < data.length; i += 1) {
      _loop(i);
    }
    return _result;
  }
  var result = [];
  var _loop2 = function _loop2(_i) {
    if (filter(searchValue, value.some(function (val) {
      return val === data[_i].value && !data[_i].disabled;
    }), data[_i])) {
      result.push(data[_i]);
    }
    if (result.length >= limit) {
      return 1; // break
    }
  };
  for (var _i = 0; _i < data.length; _i += 1) {
    if (_loop2(_i)) break;
  }
  if (enhancedFilter) return enhancedFilter(searchValue, result);
  return result;
}

export { filterData };
//# sourceMappingURL=multi-filter-data.js.map
